import { Badge, Button } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { getSelectorAttribute, vyTableSelectors } from '@vy/app-selectors';
import React from 'react';

type VyTableFilterButtonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  appliedFilters: number;
};

export const VyTableFilterButton: React.FC<VyTableFilterButtonProps> = React.memo(
  ({ onClick, appliedFilters = 0 }) => {
    const isActive = appliedFilters > 0;

    return (
      <Badge
        {...(appliedFilters > 0 ? getSelectorAttribute(vyTableSelectors.filterBadge) : {})}
        badgeContent={appliedFilters > 0 ? appliedFilters : null}
        sx={{
          '& .MuiBadge-badge': {
            backgroundColor: '#5083FF',
            color: '#fff',
            fontSize: '12px',
            height: '18px',
            minWidth: '18px',
            borderRadius: '9px',
          },
        }}
      >
        <Button
          variant="text"
          color="primary"
          {...getSelectorAttribute(vyTableSelectors.filterButton)}
          sx={{
            padding: '0px 16px',
            fontSize: '14px',
            height: '40px',
            borderRadius: '4px',
            backgroundColor: isActive ? '#E7F2FF' : '#F5F6FA',
            color: isActive ? '#5083FF' : 'inherit',
            '&:hover': {
              backgroundColor: isActive ? '#D4E7FF' : '#E8EBF2',
            },
          }}
          startIcon={
            <VyIcon
              icon="Filter"
              style={{
                transform: 'scale(0.8)',
                color: isActive ? '#5083FF' : undefined,
              }}
            />
          }
          onClick={onClick}
        >
          Filters
        </Button>
      </Badge>
    );
  },
);
